import React, { useEffect, useState } from "react";
import {
  checkUserRating,
  fetchArticles,
  findArticleName,
} from "../actions/articleActions";
import { useHistory } from "react-router-dom";
import Loading from "../components/Loading";
import Articles from "./Articles";
import Comments from "../components/Comments";
import NotFound from "./NotFound";
import Rating from "./Rating";
import { FcLike } from "react-icons/fc";
import withFetchErrorHandler from "../Hocs/withFetchErrorHandler";
import { useParams } from "react-router-dom";
import Login from "../pages/Login";
const ArticlesWithErrorHandler = withFetchErrorHandler(Articles);

const Article = ({ match }) => {
  const [article, setArticle] = useState();
  const [showModal, setShowModal] = useState();
  const [otherArticles, setOtherArticles] = useState();
  const history = useHistory();
  const { name } = useParams();
  // const user = useSelector((state) => state.session);

  useEffect(() => {
    (async function fetchArticlesLists() {
      const articlesLists = await fetchArticles();

      const article = await findArticleName(name);
      console.log(article);
      setArticle(article);
      setOtherArticles(articlesLists.filter((data) => data.name !== name));

      // if (!article) return <NotFound />;
    })();
    return () => {
      setArticle("");
      setOtherArticles("");
      setShowModal(false);
    };
  }, [name]);

  if (!article) return <Loading />;
  if (article.param === "error") return <NotFound />;
  if (article.param === "invalidToken") return <Login />;
  return (
    <>
      <div className="active-article-container ">
        <Rating open={showModal} name={name} setShowModal={setShowModal} />

        {!article.rated && (
          <div className="rate-toggle-btn">
            <p>Give it a rate</p>
            <button onClick={() => setShowModal(true)}>
              <FcLike />
            </button>
          </div>
        )}
        <div className="widthContainer">
          <div
            style={{
              display: "flex",
              gap: "10px",
              height: "100px",
              alignItems: "center",
            }}
          >
            <img
              src={article.data.thumbnail}
              alt="thumbnail"
              style={{ height: "100%", width: "100px" }}
            />
            <div>
              <h1>{article.data.title}</h1>
              <p style={{ fontSize: "1.3vw" }}>
                Summary:{" "}
                <span style={{ fontStyle: "italic" }}>
                  {" "}
                  {article.data.summary}{" "}
                </span>
              </p>
              <p style={{ fontSize: "0.7rem" }}>
                Author:{" "}
                {article.data.author ? article.data.author.name : "Anonymous"}
              </p>
            </div>
          </div>

          <div className="paragraph">
            {article.data.content.map((data, i) => {
              const { id, header, content } = data;
              return (
                <div key={id} style={{ marginTop: "20px" }}>
                  <h2 style={{ wordBreak: "break-word" }}>{header}</h2>
                  <p style={{ wordBreak: "break-word" }}>{content}</p>
                </div>
              );
            })}
          </div>
        </div>
        <Comments comments={article.data.comments} id={article.data._id} />
        <div className="other-article-container widthContainer">
          <h3>Other article</h3>
          <ArticlesWithErrorHandler
            articles={otherArticles}
            message="Publish your own article now!"
          />
        </div>
      </div>
    </>
  );
};

export default Article;
